import { render, staticRenderFns } from "./RemoteControl.vue?vue&type=template&id=484c53ce"
import script from "./RemoteControl.vue?vue&type=script&lang=js"
export * from "./RemoteControl.vue?vue&type=script&lang=js"
import style0 from "./RemoteControl.vue?vue&type=style&index=0&id=484c53ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports